import './style.scss';

import React, { useState } from 'react';
import { Input, InputGroupAddon, InputGroupText } from 'reactstrap';

const inputClassName = 'input-password';

const InputPassword = ({ className, ...props }) => {
  const [shouldShowValue, setShouldShowValue] = useState(false);
  const toggleButtonIcon = shouldShowValue ? 'fa-eye' : 'fa-eye-slash';

  return (
    <React.Fragment>
      <Input
        {...props}
        className={!!className ? `${inputClassName} ${className}` : inputClassName}
        type={!shouldShowValue ? 'password' : 'text'}
      />
      <InputGroupAddon addonType="append"
        className="toggle-password-btn"
        onClick={() => setShouldShowValue(!shouldShowValue)}
      >
        <InputGroupText>
          <i className={`fa ${toggleButtonIcon}`}/>
        </InputGroupText>
      </InputGroupAddon>
    </React.Fragment>
  );
};
  
export { InputPassword }
  